module.exports = __webpack_public_path__ + "static/touch-85e5ca1043b77d824ba15e61d3cc17d3.mp3";